const rankingItems = [
  { rank: 1, title: '星际穿越2：新纪元', type: '科幻 / 动作', heat: '🔥 986万', change: 'up' },
  { rank: 2, title: '消失的真相', type: '悬疑 / 犯罪', heat: '🔥 872万', change: 'up' },
  { rank: 3, title: '繁花似锦', type: '都市 / 情感', heat: '🔥 765万', change: 'down' },
  { rank: 4, title: '暗夜追踪者', type: '动作 / 惊悚', heat: '🔥 691万', change: 'new' },
  { rank: 5, title: '长安十二时辰2', type: '古装 / 悬疑', heat: '🔥 634万', change: 'up' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 mx-auto max-w-[1440px]">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-700 bg-accent-100 rounded-full mb-3">
            实时热度
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热度榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            基于全站播放量与搜索热度实时更新的影视排行榜
          </p>
        </div>

        <div className="max-w-2xl mx-auto bg-background-50 rounded-xl border border-background-200/60 overflow-hidden">
          {rankingItems.map((item, i) => (
            <a
              key={i}
              href="#cards"
              className={`flex items-center gap-4 px-5 py-4 hover:bg-background-100 transition-colors no-underline ${i < rankingItems.length - 1 ? 'border-b border-background-200/60' : ''}`}
            >
              <div className={`shrink-0 w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold ${
                item.rank === 1 ? 'bg-accent-500 text-background-50' :
                item.rank === 2 ? 'bg-primary-500 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 truncate">{item.title}</h3>
                <span className="text-xs text-foreground-400">{item.type}</span>
              </div>
              <span className="shrink-0 text-xs font-medium text-accent-600">{item.heat}</span>
              <span className="shrink-0">
                {item.change === 'up' && <i className="ri-arrow-up-fill text-accent-500 text-sm"></i>}
                {item.change === 'down' && <i className="ri-arrow-down-fill text-secondary-500 text-sm"></i>}
                {item.change === 'new' && <span className="text-xs font-bold text-primary-500">NEW</span>}
              </span>
            </a>
          ))}
        </div>

        <div className="text-center mt-6">
          <a href="#index" className="whitespace-nowrap inline-flex items-center gap-2 text-sm font-medium text-accent-600 hover:text-accent-700 transition-colors">
            查看完整榜单 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}